import React from 'react'

import Container from '../Container'

import { Typography } from '@material-ui/core'

const styles = {
  subjectHeader: {
    fontWeight: 700,
    textAlign: 'center',
  },
}

// Klucz grupy z reduceToCommonValues to tekst: brak tematu trafia pod 'undefined' lub 'null'.
const hasSubject = (subject) => Boolean(subject) && subject !== 'undefined' && subject !== 'null'

// Eksport: QuestionsPerTrainerAndSubject sprawdza, czy nagłówek istnieje, zanim poda jego id w aria-labelledby.
export const headerText = ({ trainer, subject, trainerMissing }) => {
  if (trainer) return `${trainer.firstName} ${trainer.lastName}${hasSubject(subject) ? ` – ${subject}` : ''}`
  // Dane prowadzącego się nie wczytały (404, błąd sieci): nagłówek z samym tematem, bez imienia i nazwiska.
  if (trainerMissing && hasSubject(subject)) return subject
  return null
}

const TrainerAndSubjectHeader = (props) => {
  const text = headerText(props)

  return (
    text ?
      <Container
        colored={true}
      >
        <Typography
          id={props.id}
          variant={'h6'}
          style={styles.subjectHeader}
        >
          {text}
        </Typography>
      </Container>
      :
      null
  )
}

export default TrainerAndSubjectHeader
